import styles from "./MFrame.module.css";
import type { ReactNode, HTMLAttributes } from "react";

interface MFrameProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
}

/**
 * MFrame atom: A flexible container with soft shadow, padding, and rounded corners.
 * Usage: Place any content inside to get a card-like appearance.
 */
const MFrame = ({ children, className = "", ...props }: MFrameProps) => {
  return (
    <div className={`${styles.mframe} ${className}`} {...props}>
      {children}
    </div>
  );
};

export default MFrame;
